import React from "react";
import { useSelector } from "react-redux";
import { Button, Modal, Image } from "semantic-ui-react";

// Actions
import ImageModalAction from "@common/redux/actions/ImageModalAction";

const ImageModal = () => {
  const { open, title, image } = useSelector((store) =>
    ImageModalAction.getStatePath(store),
  );

  const closeModal = () => {
    ImageModalAction.reset();
  };

  return (
    <Modal open={open} onClose={closeModal} size="tiny">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <Image src={`data:image/jpg;base64,${image}`} centered />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={closeModal} color="red">
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ImageModal;
